// src/components/8.js
import React from 'react';

const Componente8 = () => {
  return (
    <div className="component-container">
      <h2>Número de Propósito: 8</h2>
      <p>
        Para una persona nacida el día 8, el número de propósito asociado sería 8.
      </p>
      <p>
        En numerología, el número 8 está relacionado con el poder, la ambición y la manifestación. El propósito de una persona nacida en el octavo día del mes puede incluir:
      </p>
      <ul>
        <li><strong>Buscar el Éxito Material:</strong> La persona tiene un propósito relacionado con alcanzar metas materiales y financieras. Suelen ser ambiciosas y trabajadoras en su camino hacia el éxito.</li>
        <li><strong>Desarrollar el Liderazgo:</strong> El número 8 está asociado con la capacidad de liderar y dirigir a otros. Estas personas pueden sentirse llamadas a ocupar posiciones de autoridad y responsabilidad.</li>
        <li><strong>Manifestar sus Deseos:</strong> El propósito incluye la capacidad de manifestar sus deseos y ambiciones, utilizando su determinación y enfoque para lograr sus objetivos.</li>
        <li><strong>Equilibrar Poder y Responsabilidad:</strong> Las personas con este número tienen el propósito de aprender a equilibrar el poder con la responsabilidad, utilizando su influencia para el bien común.</li>
        <li><strong>Superar Desafíos:</strong> Tienen la capacidad de enfrentar y superar obstáculos en su camino hacia el éxito, convirtiendo los desafíos en oportunidades de crecimiento.</li>
      </ul>

      <h3>Características del Día de Nacimiento: 8</h3>
      <ul>
        <li><strong>Ambiciosas:</strong> Las personas nacidas el día 8 son extremadamente ambiciosas y están dispuestas a trabajar duro para alcanzar sus metas y sueños.</li>
        <li><strong>Líderes Naturales:</strong> Suelen tener cualidades de liderazgo innatas, lo que les permite guiar a otros con confianza y autoridad.</li>
        <li><strong>Determinación:</strong> Tienen una gran determinación y perseverancia. No se rinden fácilmente y son capaces de trabajar a largo plazo por lo que desean.</li>
        <li><strong>Habilidades de Negocio:</strong> Estas personas suelen tener un talento especial para los negocios y la gestión, lo que les permite prosperar en entornos empresariales.</li>
        <li><strong>Justicia y Equidad:</strong> A menudo tienen un fuerte sentido de justicia y buscan equilibrar el poder en sus relaciones y en el entorno en el que se desenvuelven.</li>
      </ul>

      <h4>Desafíos</h4>
      <ul>
        <li><strong>Materialismo:</strong> Pueden volverse excesivamente materialistas, enfocándose demasiado en el éxito y las posesiones materiales, a veces a expensas de relaciones personales.</li>
        <li><strong>Falta de Equilibrio:</strong> Su ambición puede llevarles a descuidar otros aspectos importantes de la vida, como la salud, las relaciones y el bienestar emocional.</li>
        <li><strong>Control:</strong> Pueden tener dificultades para delegar y confiar en otros, lo que puede generar tensiones en sus relaciones personales y laborales.</li>
      </ul>

      <h4>Resumen</h4>
      <p>
        Las personas nacidas el día 8 son ambiciosas, determinadas y nacidas para liderar. Su propósito en la vida está centrado en la búsqueda del éxito material, el desarrollo de habilidades de liderazgo y la capacidad de manifestar sus deseos. Son resilientes y enfrentan desafíos con valentía. Sin embargo, deben ser conscientes de los peligros del materialismo y encontrar un equilibrio saludable entre sus ambiciones y otros aspectos de su vida.
      </p>
    </div>
  );
};

export default Componente8;
